<div class="main-content !px-0">
    <div
        class="flex items-center justify-end mb-2"
        *ngIf="!hideReloadButton && order?.version_code! > 0 && order?.current_state !== OrderState.Complete"
    >
        <button
            tuiButton
            appearance="outline"
            size="s"
            [showLoader]="(isLoading$ | async) || false"
            (click)="onRefresh()"
            icon="svg::refresh"
        >
            {{ 'reload' | transloco }}
        </button>
    </div>

    <div class="order-status-wrapper">
        <ng-container *ngFor="let item of states || []">
            <us-order-state [item]="item"></us-order-state>
        </ng-container>

        <ng-container *ngIf="!order?.states?.length">
            <us-empty></us-empty>
        </ng-container>
    </div>
    <ng-container
        *ngIf="order && order.payment_type !== PaymentType.Cash && order.current_state === OrderState.PendingPayment"
    >
        <div class="mt-5 grid grid-cols-1 md:grid-cols-2 gap-2">
            <button
                tuiButton
                size="m"
                appearance="outline"
                (click)="checkTransactionStatus()"
                [showLoader]="(isLoading$ | async) || false"
            >
                <tui-svg src="svg::check-payment" class="mr-2"></tui-svg>
                {{ 'check_transaction_status' | transloco }}
            </button>

            <a tuiButton size="m" appearance="outline" [href]="linkPayment" *ngIf="linkPayment">
                <tui-svg src="svg::payment" class="mr-2"></tui-svg>
                {{ 'link_payment' | transloco }}
            </a>
        </div>
    </ng-container>
</div>
